import { Logo } from "./Logo";
import { LLink } from "./util";

export const Footer = () => (
  <div className="border-t border-gray">
    <div className="grid lg:grid-cols-2 my-4">
      <div />
      <ul className="flex space-x-6">
        <Logo />
        <LLink link="over">Over</LLink>
        <LLink link="terms">Algemene voorwaarden</LLink>
        <LLink link="privacy">Privacy Policy</LLink>
      </ul>
    </div>
  </div>
);
